<template>
  <main class="m-about-us-page">
    <section class="about-us">
      <v-container class="container-about pa-0">
        <v-row no-gutters style="margin-top: 180px">
          <v-col>
            <div class="d-flex flex-column align-center justify-center">
              <div>
                <h1 class="mt-4 mb-6">About Us</h1>
                <p style="text-align: justify">
                  DigiTrial is an emerging digital marketing company. We
                  specialize assisting Clinical Research Institutes in
                  recruiting patients for their studies. Our outreach in finding
                  patients are not only confined into social media; we use
                  various digital advertising tools and techniques to produce
                  diverse patient groups for studies
                </p>
                <p style="text-align: justify">
                  Our goal is to digitally automate the patient recruitment
                  process. In addition, we provide utility services to create an
                  advertisement, pre-screen a patient and assist in retaining
                  them in separate studies. We aim to take away the burden of
                  recruiting a patient away from Clinical Research Institutes.
                  Thus, we eventually empower them in focusing on important
                  research works.
                </p>
              </div>
            </div>
          </v-col>
          <v-col class="d-flex justify-center align-center pl-5">
            <v-img max-width="450px" src="@/assets/mouchak_logo.svg" />
          </v-col>
        </v-row>
      </v-container>
    </section>
  </main>
</template>

<script>
export default {
  name: "AdAboutUs",
  metaInfo: {
    title: "About Zeda",
    meta: [
      { charset: "utf-8" },
      { name: "description", content: "This is the about us page for Zeda." }
    ]
  },
  data() {
    return {};
  },
  methods: {},
  computed: {}
};
</script>

<style lang="scss">
@import "@/scss/_colors";
.container-about {
  max-width: 1170px;
}
.about-us {
  min-height: calc(70vh);
  background-color: #ffff;
}
.m-about-us-page {
  margin-top: 80px;
}
</style>
